export enum routeName {
  NOT_FOUND = 'not-found',

  // Booking flow routes
  LANDING_PAGE = 'landing-page',
  SESSIONS_LISTING_PAGE = 'sessions-listing-page',
  SESSION_DETAILS = 'session-details',
  SCENE_SELECTION = 'scene-selection',
  ADD_ONS_SELECTION = 'add-ons-selection',
  SCHEDULE_SESSION = 'schedule-session',
  CHECKOUT_SUMMARY = 'checkout-summary',
  CHECKOUT_PRE_PAY = 'checkout-pre-pay',
  CHECKOUT_TERMS = 'checkout-terms',
  CHECKOUT_PAY = 'checkout-pay',
  ORDER_COMPLETE_STRIPE = 'order-complete-stripe',
  CONFIRMATION = 'confirmation',

  // Debug / utility routes
  DEBUG_RESET_DATA = 'debug-reset-data'
}
